import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import resources_en_AU from './en/AU/strings.json';
import resources_en_US from './en/US/strings.json';
import resources_pseudo from './pseudo/strings.json';
import resources_dev from './dev/strings.json';
import { i18nConfig } from '../state/i18nConfig';
import { I18nLanguage } from './language.enum';

// Extend the type definitions of the 'i18next' module
declare module 'i18next' {
  // Enhance type safety by extending the CustomTypeOptions interface of i18next.
  // * Ensures that non-existent keys cannot be used.
  // * Ensures that non-existent namespaces cannot be used.
  export interface CustomTypeOptions {
    defaultNS: typeof defaultNS;
    resources: typeof resources['dev'];
  }
}

const supportedLngs: string[] = Object.values(I18nLanguage);

const resources = {
  enAU: resources_en_AU,
  enUS: resources_en_US,
  pseudo: resources_pseudo,
  dev: resources_dev,
};

const defaultNS: string[] = ['translations'];
const additionalNS: string[] = ['prefs'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: i18nConfig.language,
    fallbackLng: I18nLanguage.enUS,
    supportedLngs,
    debug: false,
    ns: defaultNS.concat(additionalNS),
    defaultNS,
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
      formatSeparator: ',',
    },
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'a', 'href', 'i'],
    },
  })
  .catch((error) => {
    // TODO : Should we have a logger for this or use Bugsnag?
    console.error('error', error);
  });

export default i18n;
